import { Controller } from '@hotwired/stimulus';

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import luxon3Plugin from '@fullcalendar/luxon3';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';

export default class extends Controller {
  connect() {
    this.baseEventsUrl = this.element.dataset.baseEventsUrl;
    this.calendars = JSON.parse(this.element.dataset.calendarsJson);
    this.calendar = new Calendar(this.element, {
      timeZone: 'Europe/London',
      firstDay: 1,
      plugins: [
        dayGridPlugin,
        listPlugin,
        timeGridPlugin,
        bootstrap5Plugin,
        luxon3Plugin,
      ],
      themeSystem: 'bootstrap5',
      initialView: 'dayGridMonth',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,listWeek',
      },
      eventSources: this.calendars.map((calendar) => {
        const eventsUrl = `${
          this.baseEventsUrl
        }?calendar_id=${encodeURIComponent(calendar.id)}`;
        return {
          url: eventsUrl,
          color: calendar.hexColor,
        };
      }),
      eventDataTransform: (eventData) => {
        // Transform the event data from the API to match FullCalendar's expected format
        return {
          title: eventData.subject,
          start: eventData.start.dateTime,
          end: eventData.end.dateTime,
          url: eventData.webLink, // Link to the event in Outlook
        };
      },
      eventClick: this.eventClick.bind(this),
    });
    this.calendar.render();
  }

  eventClick(event) {
    if (event.event.url) {
      event.jsEvent.preventDefault();
      window.open(event.event.url, '_blank');
    }
  }
}
